import { buildRoute } from '@direct-frontend/modules-router';

export const rootRoute = buildRoute('/');
